// AUTO-GENERATED from the live ester1.fi content (DatoCMS export).
// Safe to hand-edit: this is now the source of truth for site content.

const { asset } = require('./assets');

const talo = {
  seoMetaTags: {
    tags: [
      {
        tagName: "title",
        content: "Talo keskellä uutta Pasilaa | Ester1",
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:title",
          content: "Talo keskellä uutta Pasilaa",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:title",
          content: "Talo keskellä uutta Pasilaa",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "description",
          content: "Ester1 on vuonna 2022 täysin uudistettu kuuden kerroksen toimistotalo, jossa on historiansa aikana toiminut monia merkittäviä suomalaisia yrityksiä. Tutustu kohteeseen.",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:description",
          content: "Ester1 on vuonna 2022 täysin uudistettu kuuden kerroksen toimistotalo, jossa on historiansa aikana toiminut monia merkittäviä suomalaisia yrityksiä. Tutustu kohteeseen.",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:description",
          content: "Ester1 on vuonna 2022 täysin uudistettu kuuden kerroksen toimistotalo, jossa on historiansa aikana toiminut monia merkittäviä suomalaisia yrityksiä. Tutustu kohteeseen.",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:card",
          content: "summary",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "article:modified_time",
          content: "2022-06-21T09:03:25Z",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "article:published_time",
          content: "2019-12-30T18:39:18Z",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:locale",
          content: "fi_FI",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:type",
          content: "article",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:site_name",
          content: "Ester1 – toimistotila keskellä uutta Pasilaa ",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:image",
          content: "/content-images/1655981672-yleiset-tilat-10-web.jpg",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:image",
          content: "/content-images/1655981672-yleiset-tilat-10-web.jpg",
        },
      },
    ],
  },
  title: "Talo keskellä uutta Pasilaa",
  lead: "Ester1 on vuonna 2022 täysin uudistettu kuuden kerroksen toimistotalo, jossa on historiansa aikana toiminut monia merkittäviä suomalaisia yrityksiä.",
  content: "<p>Peruskorjauksen yhteydess&auml; olemme kiinnitt&auml;neet erityist&auml; huomiota talon ymp&auml;rist&ouml;yst&auml;v&auml;llisyyteen, mink&auml; ansiosta voimme tarjota viihtyis&auml;t ja vastuulliset toimistotilat 10&ndash;150 hengen yrityksille. Tiilisein&auml;inen talo sijaitsee Pasilansillan l&auml;nnenpuoleisessa p&auml;&auml;dyss&auml;, osoitteessa Esterinportti 1.&nbsp;</p>",
  heroLayer: {
    alpha: 0,
    blue: 0,
    green: 0,
    red: 0,
  },
  imgHero: asset("1655981672-yleiset-tilat-10-web.jpg", {
    sizes: "(max-width: 1600px) 100vw, 1600px",
    aspectRatio: 1.777778,
  }),
  otsikko1: "Modernit ja  yhteisölliset  tilat",
  teksti1: "Ester1:n tilat on suunniteltu nykyaikaiset työskentelytavat ja yritysten vaatimukset tiukasti silmällä pitäen. Meillä korostuu visuaalinen ja inspiroiva ympäristö, jonka uskomme lisäävän intoa työpäivään ja parantavan tuotteliaisuutta. Tilat on suunniteltu muunneltaviksi, jotta tilaratkaisu on mahdollista toteuttaa aina yrityksenne vaativimmatkin tarpeet huomioiden. Tilaratkaisu suunnitellaan aina yhdessä yrityksenne kanssa.",
  kuva1: asset("1577112840-greensquare.jpg", {
    alt: "Ester1 sisätila",
    sizes: "(max-width: 536px) 100vw, 536px",
    aspectRatio: 1,
  }),
  otsikko2: "Ympäristö-ystävällisyys  ennen kaikkea",
  teksti2: "Talolle haetaan arvostettua LEED Gold -ympäristöluokitusta. Talo käyttää ainoastaan vihreästi tuotettua sähköä ja niin hanat kuin tiskikoneet ovat vettä säästäviä. Peruskorjaukset yhteydessä kierrätimme kaikki materiaalit sekä edistimme vähäpäästöisten rakennusmateriaalien kehittämistä käyttämällä M1-luokiteltuja pintamateriaaleja. Talosta löytyy myös runsaasti pyöräpaikkoja sekä sähköautojen latauspistokkeita.",
  kuva2: asset("1614931354-neuvottelusquare-uusi.jpg", {
    alt: "Neuvotteluhuone",
    sizes: "(max-width: 536px) 100vw, 536px",
    aspectRatio: 1,
  }),
  otsikko3: "LEED Gold -ympäristö-luokitus",
  teksti3: "LEED-sertifiointijärjestelmässä arvioidaan tilojen, rakennusten ja alueiden ympäristöominaisuuksia. Kohteelle haettava sertifikaatti todentaa, että rakennus suunnitellaan, rakennetaan ja ylläpidetään tiukkojen ympäristötavoitteiden mukaisesti. Sertifioinnin myötä saadaan työkalut rakennuksen kestävään ylläpitoon ja säästöihin energiankulutuksessa.",
  kuva3: asset("1577724144-leed-gold-sertifikaatti.png", {
    alt: "Lead Gold -sertifikaatti",
    sizes: "(max-width: 536px) 100vw, 536px",
    aspectRatio: 1,
  }),
  valahdyksiaOtsikko: "Välähdyksiä Ester1stä",
};

module.exports = { talo };
